//dependencias
import React from "react";
import { Route, Switch } from "react-router-dom";

//componentes

import Reportes from "./components/reportes";
import PlanillaI from "./components/planillaInscripcion";
import Configuracion from "./components/configuracion/";
import Inicio from "./components/Inicio";
import Login from "./components/Login";
import Pagina404 from "./components/Pagina404";


import Medicos from './components/maestroMedicos';
import Casos from './components/casos';
import Citas from './components/citasPaciente';
import Becas from './components/becas';
import ReporteCita from './components/reporteCitas';
import Chat from "./components/Chat";


const AppRoutes = () => (
  <Switch>
    
    <Route exact strict path="/chat" component={Chat} />
    <Route exact path="/reporteCita" component={ReporteCita} />
    <Route exact path="/becados" component={Becas} />
    <Route exact path="/citas" component={Citas} />
    <Route exact path="/medicos" component={Medicos} />
    <Route exact strict path="/casos" component={Casos} />
    <Route exact path="/reportes" component={Reportes} />
    <Route exact strict path="/planillai" component={PlanillaI} />
    <Route exact strict path="/configuracion" component={Configuracion} />
    <Route exact strict path="/login" component={Login} />
    {/* <Route exact strict path="/" component={Citas} /> */}
    <Route exact strict path="/" component={Inicio} />
   
    
    <Route component={Pagina404} />
  </Switch>
);
export default AppRoutes;
